var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"ml-5"},[_vm._v(_vm._s(_vm.name))]),(_vm.showExternalLink)?_c('a',{staticClass:"ml-5",attrs:{"href":_vm.link,"target":"_blank"}},[_c('i',{staticClass:"mdi mdi-open-in-new"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }